import { Empty, Button, HeaderTemplate } from "../styles";
import { useNavigate } from "react-router-dom";
import { logError } from "../api/misc";

function FallBack({ error, resetErrorBoundary }) {
  console.error(error);

  const errorObj = {
    type: error.name,
    message: error.message,
    stack: error.stack,
  };

  logError(errorObj);

  const navigate = useNavigate();

  const goBackFunc = () => {
    navigate("/");
    resetErrorBoundary();
  };

  return (
    <>
      <HeaderTemplate>
        <div className="header"></div>
      </HeaderTemplate>
      <Empty>
        <h1>Oops! Something went wrong.</h1>
        <Button onClick={goBackFunc} className="autoWidth">
          Back Home
        </Button>
      </Empty>
    </>
  );
}

export default FallBack;
